import { takeEvery } from '@redux-saga/core/effects'; // NOSONAR
import {
  GlobalAction,
  GlobalActions,
  SOFORTSCHUTZ_ACTIVE_REQUEST,
  UpdateBeginnAblaufPayload,
} from '@ps20-frontend/shop-integration-redux';
import { addTaasLoadingActions } from './addTaasLoadingActions.util';
import { addTaasUpdateAppErrorHandling } from './addTaasUpdateAppErrorHandling';

export const updateAppActionsGenerator = ({
  appId,
  angebotsId,
  beginn,
}: UpdateBeginnAblaufPayload) => {
  return [
    new GlobalActions().updateBeginnAblauf({ appId, angebotsId, beginn }),
    new GlobalActions().updateSofortschutzActive(appId, angebotsId),
  ];
};

export const updateAppSuccessActions = () => [GlobalActions.UPDATE_SOFORTSCHUTZ_ACTIVE_FINISHED];

export const updateAppFailActions = () => [
  SOFORTSCHUTZ_ACTIVE_REQUEST.SOFORTSCHUTZ_ACTIVE_REQUEST_FAILED,
];

export const updateAndTarifiere = addTaasLoadingActions(
  addTaasUpdateAppErrorHandling(
    updateAppActionsGenerator,
    updateAppSuccessActions,
    updateAppFailActions,
  ),
);

export const vorversicherungChangedActionsGenerator = (): GlobalAction<unknown>[] => [];

export const vorversicherungChangedAndTarifiere = addTaasLoadingActions(
  addTaasUpdateAppErrorHandling(
    vorversicherungChangedActionsGenerator,
    updateAppSuccessActions,
    updateAppFailActions,
  ),
);

export function* watchSofortschutzActiveSaga() {
  yield takeEvery(GlobalActions.VORVERSICHERUNG_ABLAUFDATUM_CHANGED, vorversicherungChangedAndTarifiere);
  yield takeEvery(GlobalActions.VERSICHERUNGSBEGINN_CHANGED, updateAndTarifiere);
}
